export default "<div class=\"alert alert-danger text-center\">\n  <i class=\"fa fa-times-circle\"></i>&nbsp;\n  <ng-content></ng-content>\n</div>\n"